import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";
const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};
function AbstractPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Abstract</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              It has been witnessed since the beginning of history, that humans
              have a tendency to prove themselves to be superior to all other
              living organisms. It is now truthful to state that there exists an
              ego among the human breed to dominate the available resources for
              their immediate benefits. Previously, this was just altering the
              local climate which was almost negligible as nature has a
              self-cleansing and maintaining property, but from past few
              decades, due to extreme pressure on nature, the climate across the
              globe is being affected due to anthropogenic activities.
              Initially, climate change was considered essential only on
              academic basis, but over the past few years, due to increased
              awareness among people, it has become one of the most concerned
              and researched topics, also being one of the most significant
              developmental challenges for humans (
              <a href="#_bookmark47">Lal, 2017</a>). One of the most critical
              factors of changing climate can be inferred as unplanned and
              hap-hazardous urban areas development. Urbanization has conve-
              niently brought numerous positive changes such as making cities
              economically sustainable, increasing the GDP per capita, providing
              a better standard of living and quality of life, improved medical
              facilities, increased occupational opportunities, and better
              education (<a href="#_bookmark44">Keeling, 1997</a>;{" "}
              <a href="#_bookmark43">Karoly et al.,</a>{" "}
              <a href="#_bookmark43">2003</a>;{" "}
              <a href="#_bookmark82">Stott et al., 2006</a>). However, due to
              increased demographic pressure on the cities due to large movement
              of population from rural to urban areas, rapid and unorganized
              developments have started to come-up in cities for satisfying the
              needs of incoming residents. These changes gradually collapse the
              balance, creating problems such as unavailability of basic
              housing, lack of fresh and treated water supply, inadequate
              infrastructure, and rise in greenhouse gases as well as pollution
              levels (<a href="#_bookmark69">Ramachandra et al., 2012</a>)
            </p>
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default AbstractPage;
